export const ADD_NOTIFICATION = '🚨 Add a new notification';
export const DELETE_NOTIFICATION = '🚨 Remove a notification';
export const LOGIN_SUCCESS = '🔒 Handle a successful login attempt';
export const LOGIN_ERROR = '🔒 Handle a failed login attempt';
export const LOGOUT_SUCCESS = '🔒 Handle a successful logout';
export const COMPANY_SWITCHED = '🔒 Handle a company switch';
